'use strict';

import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import ButtonBasic from '@/components/form/ButtonBasic.vue';
export default {
  name: 'notesComponent',
  components: {
    ButtonBasic: ButtonBasic
  },
  methods: {
    deleteNote: function deleteNote(index) {
      this.$store.commit('deleteNote', index);
      this.showAddNote = false;
    },
    toggleShowAddNote: function toggleShowAddNote() {
      console.log('trying to show notes');
      this.showAddNote = true;
    },
    loadContent: function loadContent(Note) {
      this.editTitle = Note.title;
      this.editText = Note.text;
      this.editId = Note.id;
    },
    toggleMainMenu: function toggleMainMenu() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.$store.state.ShowMainMenu) {
                _this.$store.commit('mainMenuClose');
              } else {
                _this.$store.commit('mainMenuOpen');
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openSidebar: function openSidebar() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$store.commit('mainMenuOpen');
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    saveNoteEdit: function saveNoteEdit() {
      this.$store.commit('saveNote', {
        index: this.editId,
        note: {
          type: this.noteType,
          title: this.editTitle,
          text: this.editText,
          show: false,
          editing: false,
          hasEdits: false
        }
      });
      this.editTitle = '';
      this.editText = '';
      this.editId = '';
      this.showAddNote = false;
    },
    addNote: function addNote() {
      if (this.noteTitle && this.noteText) {
        this.$store.commit('addNote', {
          title: this.noteTitle,
          text: this.noteText,
          show: false,
          editing: false,
          hasEdits: false
        });
        this.noteTitle = '';
        this.noteText = '';
        this.showAddNote = false;
      } else {
        this.$store.commit('showSnackbarWarning', 'Enter a title and text!');
      }
    },
    mounted: function mounted() {
      console.log('<<<<<<<<< notesComponent mounted >>>>>>>>>');
      //notesComponent__title
    }
  },
  data: function data() {
    return {
      noteType: null,
      // text, drawing
      noteTitle: '',
      noteText: '',
      editId: '',
      editTitle: '',
      editText: '',
      showAddNote: false,
      addNewNote: false
    };
  }
};